import React, { useMemo } from 'react'
import Dropzone from 'react-dropzone'
import { compose } from 'recompose'
import { withHooks } from '../../enhancers'

const Image = props => (
  <div style={{ pointerEvents: props.readOnly ? 'none' : 'auto' }}>
    {props.field.value && !props.readOnly && (
      <button
        onClick={props.onClear}
        className="btn btn-danger btn-icon btn-circle btn-sm m-r-2 "
        style={{ position: 'absolute', left: '115px', top: '0px' }}
      >
        <i className="fa fa-times" />
      </button>
    )}

    <Dropzone onDrop={props.onDrop} id="55555555">
      {({ getRootProps, getInputProps }) => (
        <section>
          <div
            style={{ cursor: 'pointer' }}
            className="w-100 h-100 rounded border border-secondary bg-grey-transparent-2 text-center p-auto"
            data-cy="drag-and-drop"
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            {!props.field.value && (
              <>
                <i className="fa fa-upload fa-3x m-t-10" />
                <div className="m-t-15">Choose File</div>
              </>
            )}
            {props.field.value && (
              <>
                <img
                  src={props.value}
                  className="w-100 h-100 rounded border border-secondary bg-grey-transparent-2 text-center p-auto"
                  alt=""
                />
              </>
            )}
          </div>
        </section>
      )}
    </Dropzone>
  </div>
)

const enhancer = compose(
  withHooks(props => {
    let testValue
    const onDrop = acceptedFiles => {
      testValue = acceptedFiles
      props.update(props.id, {
        [props.field.name]: Object.assign(acceptedFiles[0], {
          preview: URL.createObjectURL(acceptedFiles[0]),
        }),
      })

      props.form.setFieldValue(
        props.field.name,
        Object.assign(acceptedFiles[0], {
          preview: URL.createObjectURL(acceptedFiles[0]),
        })
      )
    }

    const onClear = () => {
      props.form.setFieldValue(props.field.name, '')
    }

    let value = useMemo(() => {
      if (props.field.value) {
        if (props.field.value.preview) {
          value = props.field.value.preview
        } else {
          value = props.field.value
          props.form.setFieldValue(props.field.name, props.field.value)
        }
      }
      return value
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.field.value])

    return { onDrop, onClear, value, testValue }
  })
)

export default enhancer(Image)
